import { warn } from "@/lib/log";

export const socialLinks = (shareUrl, text) => {
  const u = encodeURIComponent(shareUrl);
  const t = encodeURIComponent(text);
  return {
    whatsapp: `https://wa.me/?text=${t}%20${u}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${u}&quote=${t}`,
    twitter: `https://twitter.com/intent/tweet?text=${t}&url=${u}`,
    telegram: `https://t.me/share/url?url=${u}&text=${t}`,
  };
};

export const canNativeShare = () => typeof navigator !== "undefined" && Boolean(navigator.share);

export const nativeShare = async (data) => {
  try { await navigator.share(data); } catch (err) { if (err?.name !== "AbortError") warn("Share failed:", err); }
};

export const copyText = async (text) => {
  try { await navigator.clipboard.writeText(text); } catch (err) { warn("Clipboard failed:", err); }
};
